export const NEWBUILDING_COMPARE_ENABLED_CONFIG = 'Newbuilding.Compare.Enabled';
export const NEWBUILDING_COMPARE_MOBILE_ENABLED_CONFIG = 'Newbuilding.CompareMobile.Enabled';

/**
 * Страница сравнения ЖК в compare-frontend. Формат ссылки повторяет десктопный хаб сравнения:
 * на мобильных `activeTab` игнорируется, там всегда открывается сравнение ЖК.
 */
export const NEWBUILDING_COMPARISON_URL = '/compare/?activeTab=newbuildings';
